import { Controller } from '@hotwired/stimulus'
// @ts-expect-error: el-transition is not typed
import { enter, leave } from 'el-transition'

// Connects to data-controller="sidebar"
export default class extends Controller {
  static targets = [
    'main',
    'slideout',
    'excludeClick',
  ]

  declare readonly mainTarget: HTMLElement
  declare readonly slideoutTarget: HTMLElement
  declare readonly excludeClickTargets: HTMLElement[]

  connect (): void {
    document.addEventListener('close-sidebar', this.hide.bind(this))
  }

  disconnect (): void {
    document.removeEventListener('close-sidebar', this.hide.bind(this))
  }

  show (): void {
    this.mainTarget.classList.remove('hidden')

    // Prevent scrolling when the mobile sidebar is open
    if (this.mainTarget.id === 'mobile-shared-sidebar') {
      document.body.classList.add('overflow-hidden')
    }

    enter(this.slideoutTarget)
  }

  hide (event?: Event): void {
    if (event && this.excludeClickTargets.some(target => target.contains(event.target as Node))) {
      return
    }

    leave(this.slideoutTarget).then(() => {
      this.mainTarget.classList.add('hidden')

      // Restore scrolling if we had disabled it for mobile sidebar
      if (this.mainTarget.id === 'mobile-shared-sidebar') {
        document.body.classList.remove('overflow-hidden')
      }
    })
  }
}
